import { fetchAuthorInfo } from "./api";

export const isURL = (value) => {
  // Regular expression for a simple URL pattern
  const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlPattern.test(value);
}


export const getUpdatedPermission = async (permission) => {
  const modifiedPermissions = await Promise.all(
    permission.map(async (item) => {
      const { displayName, photoURL } = await fetchAuthorInfo(item?.hd_id);

      return {
        ...item,
        displayName,
        photoURL
      };
    })
  );

  const sortedPermissions = modifiedPermissions.sort((a, b) =>
    a.permission === "owner" ? -1 : b.permission === "owner" ? 1 : 0
  );

  return sortedPermissions;
}


export const getCompanyName = (email) => {
  if (email && email.includes('@')) {
    const domain = email.split('@')[1];
    const companyName = domain.split('.')[0];

    // List of generic company names
    const genericCompanies = ['gmail', 'yahoo', 'outlook', 'hotmail'];

    // Check if the company name is generic
    if (genericCompanies.includes(companyName)) {
      return null;
    } else {
      return companyName;
    }
  } else {
    return null
  }
}